import React from 'react'
import { Layout, Row, Col, Button, Spin, Icon, message, Typography, Tabs } from 'antd'
import { get } from 'lodash'
import moment from 'moment'
import { RequestV2 as Request, Modules, Lib } from 'App/Utils'
import PageError from 'App/Component/PageError'
import { PageMerchant, PageSkuMapping, PageSetting } from './Pages'

const { TabPane } = Tabs

class PageDetail extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      errorResponse: null,
      merchantGroup: null,
      readOnly: !get(props, 'currentPermissionSet', []).some(code => (code || '').includes('.change_'))
    }
    this.refPermissions = ['.view_']
    this.headerDescriptions = [
      { key: 'name', label: 'Name' },
      { key: 'exporter_name', label: 'Exporter Name' },
      { key: 'old_sequence', label: 'Old Sequence' },
      { key: 'mapping_mode.name', label: 'Mapping Mode' },
      { key: 'show_seed', label: 'Show Seed', type: 'bool' },
      { key: 'created', label: 'Created at', type: 'date' },
      { key: 'modified', label: 'Modified at', type: 'date' },
    ]
  }

  retrieve = (keyLoading = 'isLoading', callback = () => null) => {
    this.setState({ [keyLoading]: true }, () => {
      Request(
        'get',
        'module-merchant-group-detail',
        {},
        {},
        [this.props.match.params.id],
        this.retrieveSuccess,
        this.retrieveFailed,
        { keyLoading, callback }
      )
    })
  }

  retrieveSuccess = (response, extra) => {
    this.setState({ [extra.keyLoading]: false, merchantGroup: response.data })
  }

  retrieveFailed = (error, extra) => {
    this.setState({ [extra.keyLoading]: false, errorResponse: get(error, 'response') }, () => extra.callback())
  }

  getDescElems = () => {
    const { merchantGroup } = this.state
    return (
      <Row className='ant-desc-custom' type='flex' gutter={[12, 12]} style={{ marginTop: '12px' }}>
        {
          this.headerDescriptions.map(item => (
            <Col key={item.key} xs={24} sm={12} lg={8}>
              <Row className='header-content-item'>
                <span className='ant-descriptions-item-label ant-descriptions-item-colon'>
                  {item.label}
                </span>
                <span className='ant-descriptions-item-content'>
                  {this.getValue(merchantGroup, item.key, item.type)}
                </span>
              </Row>
            </Col>
          ))
        }
      </Row>
    )
  }

  getValue = (record, key, type) => {
    if (type === 'long_date') {
      return (
        <>
          {moment(record[key]).format('ddd, DD MMM YYYY hh:mm A')}
          <Typography.Text type='secondary'> ({moment(record[key]).fromNow()})</Typography.Text>
        </>
      )
    } else if (type === 'date') {
      return moment(record[key]).format('ddd, DD MMM YYYY hh:mm A')
    } else if (type === 'bool') {
      return Modules.renderStatusAIU(get(record, key))
    } else {
      return get(record, key) || '-'
    }
  }

  onGoHome = () => {
    Lib.historyAction(this.props.history, '/merchant/group').goBack()
  }

  setMerchantGroup = (merchantGroup) => {
    this.setState({ merchantGroup })
  }

  componentDidMount() {
    this.retrieve()
  }

  render() {
    const { userReducer, history, location, match } = this.props
    const { isLoading, errorResponse, readOnly, merchantGroup } = this.state

    if (isLoading) {
      return (
        <div style={{ paddingTop: 100, textAlign: "center" }}>
          <Spin
            size="large"
            tip="Loading..."
            indicator={
              <Icon type="loading" style={{ fontSize: "4rem" }} spin />
            }
          />
        </div>
      )
    }

    return merchantGroup ? (
      <Layout className='um-layout'>
        <div className='ant-page-header has-footer'>
          <Row type='flex' justify='space-between' gutter={[12, 12]} style={{ borderBottom: '1px solid #e8e8e8' }}>
            <Col>
              <Row type='flex' align='middle'>
                <Icon className='ant-page-header-back-button' type='arrow-left' style={{ marginRight: '16px' }} onClick={this.onGoHome} />
                <Col className='header-title text-ellipsis'>
                  Merchant Group
                </Col>
                {readOnly && (
                  <Col style={{ fontSize: '12px', fontWeight: 500, backgroundColor: '#1890ff', color: '#fff', padding: '0 12px 2px 12px', borderRadius: '14px', marginLeft: '12px' }}>
                    Read Only
                  </Col>
                )}
              </Row>
            </Col>
            <Col>
              <Row type='flex' gutter={[12, 12]}>
              </Row>
            </Col>
          </Row>
          <div>
            {this.getDescElems()}
          </div>
          <div className='ant-page-header-footer'>
            <div style={{ height: '1px', backgroundColor: '#e8e8e8' }} />
          </div>
        </div>
        <div style={{ backgroundColor: '#fff', marginBottom: '24px' }}>
          <Tabs className='custom-margin-tab' tabBarGutter={0}>
            <TabPane key='merchants' tab={<span><Icon type='shop' />Merchants</span>}>
              <Row style={{ paddingBottom: '24px'}}>
                <PageMerchant userReducer={userReducer} history={history} location={location} match={match} merchantGroup={merchantGroup} />
              </Row>
            </TabPane>
            <TabPane key='skuMappings' tab={<span><Icon type='deployment-unit' />SKU Mapping</span>}>
              <Row style={{ paddingBottom: '24px'}}>
                <PageSkuMapping userReducer={userReducer} history={history} location={location} match={match} merchantGroup={merchantGroup} />
              </Row>
            </TabPane>
            <TabPane key='setting' tab={<span><Icon type='setting' />Setting</span>}>
              <Row style={{ padding: '0 24px 24px 24px'}}>
                <PageSetting readOnly={readOnly} userReducer={userReducer} merchantGroup={merchantGroup} setMerchantGroup={this.setMerchantGroup} />
              </Row>
            </TabPane>
          </Tabs>
        </div>
      </Layout>
    ) : (
      <PageError
        errorResponse={errorResponse}
        onGoBack={this.onGoHome}
        onReload={this.retrieve}
      />
    )
  }
}

export default PageDetail